// A busca identifica a pessoa em `id`; a seleção operacional usa o contrato.
export const getContratoProfissionalId = (profissional = {}) =>
	Number(
		profissional.vinculo_profissional_id ||
			profissional.vinculo_estabelecimento_id ||
			profissional.vinculo_id ||
			profissional.vinculoId ||
			0,
	) || null;

export const getContratoRotulo = (profissional = {}) => {
	if (profissional.rotulo) return profissional.rotulo;
	const id = getContratoProfissionalId(profissional);
	const tipo = profissional.nome_vinculo || profissional.nomeVinculo || 'Vínculo';
	const regime = profissional.regime_institucional?.rotulo || 'Regime não informado';
	return id ? `${tipo} — ${regime} — contrato ${id}` : 'Cadastro consultado no CNES';
};

export const selecionarContratoBusca = (resultados = [], contratoAtualId = null) => {
	if (!Array.isArray(resultados)) return null;
	if (contratoAtualId) {
		return resultados.find(
			(item) => getContratoProfissionalId(item) === Number(contratoAtualId),
		) || null;
	}
	return resultados.length === 1 ? resultados[0] : null;
};

export const getContratoVinculoTipoId = (profissional = {}) =>
	Number(
		profissional.tipo_vinculo_id ||
			profissional.vinculo_tipo_id ||
			profissional.vinculoTipoId ||
			profissional.vinculo_tipo?.id ||
			profissional.vinculo?.id ||
			profissional.tipo_vinculo?.id ||
			0,
	) || null;

export const selecionarContratoAutomatico = (
	resultados = [],
	{ contratoAtualId = null, vinculoTipoId = null } = {},
) => {
	if (!Array.isArray(resultados) || !resultados.length) return null;
	if (contratoAtualId) {
		const contratoAtual = resultados.find(
			(item) => getContratoProfissionalId(item) === Number(contratoAtualId),
		);
		if (contratoAtual) return contratoAtual;
	}
	if (vinculoTipoId) {
		const mesmoVinculo = resultados.find(
			(item) => getContratoVinculoTipoId(item) === Number(vinculoTipoId),
		);
		if (mesmoVinculo) return mesmoVinculo;
	}
	return resultados[0];
};

export const deveCriarNovoVinculoAutomaticamente = (
	contratoAtual = null,
	vinculoTipoId = null,
	jaEstaCriandoNovoVinculo = false,
) =>
	Boolean(
		Number(vinculoTipoId || 0) &&
			(jaEstaCriandoNovoVinculo ||
				(Boolean(getContratoProfissionalId(contratoAtual || {})) &&
					getContratoVinculoTipoId(contratoAtual || {}) !==
						Number(vinculoTipoId))),
	);

const normalizarRegime = (regime) => String(regime || '').trim().toUpperCase();

export const deveCriarNovoVinculoPorRegimeDiferente = (
	contratoAtual = null,
	regimeSelecionado = '',
) => {
	if (!contratoAtual) return false;
	const institucional = contratoAtual.regime_institucional || {};
	const vigenciaAtual = (Array.isArray(institucional.vigencias)
		? institucional.vigencias
		: []
	).find((vigencia = {}) => !vigencia.vigencia_fim) || {};
	const rotuloInstitucional = normalizarRegime(institucional.rotulo);
	const regimeAtual = normalizarRegime(
		institucional.regime ||
			vigenciaAtual.regime ||
			(rotuloInstitucional === 'REGIME NÃO INFORMADO'
				? ''
				: institucional.rotulo),
	);
	const regimeNovo = normalizarRegime(regimeSelecionado);
	return Boolean(
		getContratoProfissionalId(contratoAtual) &&
			regimeAtual &&
			regimeNovo &&
			regimeAtual !== regimeNovo,
	);
};

// O modal de adição já é a confirmação da intenção. Só nesse envio uma
// divergência contratual da pessoa pesquisada pode criar outro contrato; trocar
// campos no rascunho não produz efeitos colaterais.
export const deveCriarNovoVinculoNaAdicao = ({
	contratoAtual = null,
	vinculoTipoId = null,
	regimeSelecionado = '',
} = {}) => {
	if (!getContratoProfissionalId(contratoAtual || {})) return false;
	return (
		getContratoVinculoTipoId(contratoAtual || {}) !==
			Number(vinculoTipoId || 0) ||
		deveCriarNovoVinculoPorRegimeDiferente(
			contratoAtual,
			regimeSelecionado,
		)
	);
};

export const contratoCriadoEhIndependente = ({
	contratoAnteriorId = null,
	contratoNovoId = null,
} = {}) =>
	Boolean(
		Number(contratoNovoId || 0) &&
			Number(contratoNovoId) !== Number(contratoAnteriorId || 0),
	);

export const getContratoEdicaoId = (item = {}, formulario = {}) => {
	const fontes = [item, item?.dados_edicao, item?.edicao, formulario?.item, formulario?.defaults, formulario];
	for (const fonte of fontes) {
		const id = getContratoProfissionalId(fonte || {}) ||
			getContratoProfissionalId(fonte?.profissional || {}) ||
			getContratoProfissionalId(fonte?.profissional_por_cpf || {}) ||
			getContratoProfissionalId(fonte?.edicao?.profissional_por_cpf || {}) ||
			Number(fonte?.vinculo_profissional?.id || 0);
		if (id) return id;
	}
	return null;
};

export const selecionarContratoEdicao = (resultados, item, formulario) => {
	const id = getContratoEdicaoId(item, formulario);
	return id ? selecionarContratoBusca(resultados, id) : null;
};

// Campos exclusivos do comando de cadastro. Regime da linha nunca entra aqui.
export const buildIntencaoContrato = (contratoId, novoContrato = {}) => {
	if (!novoContrato.enabled) return contratoId ? { vinculo_profissional_id: Number(contratoId) } : {};
	return {
		criar_novo_vinculo: true,
		cargo: novoContrato.cargo || '',
		telefone: String(novoContrato.telefone || '').replace(/\D/g, ''),
		...(novoContrato.carga_horaria_semanal !== '' && novoContrato.carga_horaria_semanal != null
			? { carga_horaria_semanal: Number(novoContrato.carga_horaria_semanal) }
			: {}),
		regime_institucional: {
			regime: novoContrato.regime,
			vigencia_inicio: novoContrato.vigencia_inicio,
			vigencia_fim: novoContrato.vigencia_fim || null,
		},
	};
};
